module.exports = __webpack_public_path__ + "static/media/NavAddMoney.a7393689.svg";